import { registerComponent } from '@gig/magic-common';
import StaticPageComponent from './static-page.vue.js';

var StaticPage = registerComponent(StaticPageComponent);

export { StaticPage };
